module.exports = __webpack_public_path__ + "img/BMW2_DT.7f4b7dc9.png";